import { useParams } from 'react-router';
import Button from '@/components/UI/Button';
import Card from '@/components/UI/Card/index.tsx';
import Table from '@/features/ChangeOrder/Summary/Table';
import { mockProgramReports } from '@/features/projects/components/Reports/data';
import { useApplicationForm } from '@/hooks/ReactQueryHooks/useApplicationFromQuery';
import { columns } from './columns';

export function ApplicationFormReports() {
  const { applicationFormId = '' } = useParams<string>();

  const fetchApplicationForm = useApplicationForm({
    formId: applicationFormId,
  });
  const applicationForm = fetchApplicationForm?.data?.data;

  return (
    <Card title={`${applicationForm.name} Reports`} titleElement={<Button btnStyle='btn-primary' label='Add New' />}>
      <Table tableClassName='!w-full' wrapperClassName='overflow-visible' cols={columns} data={mockProgramReports} />
    </Card>
  );
}
